import { useEffect } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { convertUnicodeToGSM7 } from "@skeepit/unicode-to-gsm7"
import { serializeMergeTagEditorToPlainText } from "./serialize"

type Props = {
  onChange: (plainText: string) => void
  encodeForSms?: boolean
}

const MergeTagOnChangePlugin = ({ onChange, encodeForSms = true }: Props) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const unregister = editor.registerUpdateListener(({
      editorState, dirtyElements, dirtyLeaves,
    }) => {
      if (dirtyElements.size === 0 && dirtyLeaves.size === 0) return

      editorState.read(() => {
        const serialized = serializeMergeTagEditorToPlainText()
        const plainText = encodeForSms ? convertUnicodeToGSM7(serialized) : serialized
        onChange(plainText)
      })
    })

    return unregister
  }, [editor, onChange, encodeForSms])

  return null
}

export default MergeTagOnChangePlugin
